import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {ApiResponse, ApiRequest} from "@gongt/ts-stl-library/request/protocol";

export const SendResetEmailUrl = `/send_reset_mail`;
export const SendResetEmailMethod = ERequestType.TYPE_POST;

export interface SendResetEmailBody extends ApiRequest {
	login: string;
	verify: string;
}

export interface SendResetEmailResponse extends ApiResponse {
	
}
